var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInactive1 = function SvgInactive1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.293V.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.326.879L11 3.73v1.563l-4.5 4.5-2.146-2.146a.5.5 0 0 0-.707 0l-3.5 3.5A.498.498 0 0 0 0 11.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-6a.498.498 0 0 0-.147-.354L12 5.293ZM9.52 1h1.418c.034 0 .062.028.062.062v1.216a.062.062 0 0 1-.103.047L9.48 1.11A.062.062 0 0 1 9.52 1Zm3.293 12H1.187A.187.187 0 0 1 1 12.813v-.848c0-.165.066-.324.182-.44l2.686-2.686a.187.187 0 0 1 .264 0l2.015 2.014a.5.5 0 0 0 .707 0l4.514-4.514a.187.187 0 0 1 .264 0l1.186 1.186a.623.623 0 0 1 .182.44v4.848a.187.187 0 0 1-.187.187Z",
    fill: "#777",
    fillRule: "nonzero"
  })));
};
export default SvgInactive1;